module.exports = __webpack_public_path__ + "images/side-img.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/side-img.png
// module id = 753
// module chunks = 17